import { easeOut, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./Header.css";
import ContactButton from "../components/ContactButton";
import bgImage from "../assets/illustrations/bg.png";
import { BOOK_CALL_URLS, GET_QUOTE_URLS } from "../constants";

export default function Header() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith("pl") ? "pl" : "en";

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: easeOut },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 1, ease: easeOut, delay: 0.4 },
    },
  };

  return (
    <header>
      <div className="header-container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="header-content"
        >
          <motion.h3 className="subtitle" variants={itemVariants}>
            {t("header.subtitle")}
            <br />
            {t("header.subtitleLine2")}
          </motion.h3>
          <motion.h1
            className="font-accent headline-big"
            variants={itemVariants}
          >
            {t("header.headline1")}
            <br />
            {t("header.headline2")}
            <br />
            {t("header.headline3")}
          </motion.h1>
          <motion.h2 className="description" variants={itemVariants}>
            {t("header.description1")}
            <br />
            {t("header.description2")}
          </motion.h2>
          <motion.div className="button-group" variants={itemVariants}>
            <ContactButton size="small" href={BOOK_CALL_URLS[lang]}>
              {t("navigation.bookCall")}
            </ContactButton>
            <ContactButton
              variant="secondary"
              size="small"
              href={GET_QUOTE_URLS[lang]}
            >
              {t("navigation.getQuote")}
            </ContactButton>
          </motion.div>
        </motion.div>

        <motion.div
          className="header-image"
          variants={imageVariants}
          initial="hidden"
          animate="visible"
        >
          <img src={bgImage} alt="Illustration" />
        </motion.div>
      </div>
    </header>
  );
}
